/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, LeasingFinanceFromJSON, LeasingFinanceToJSON, } from './';
export function LeasingAgreementFromJSON(json) {
    return LeasingAgreementFromJSONTyped(json, false);
}
export function LeasingAgreementFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'leasingAgreementId': !exists(json, 'leasingAgreementId') ? undefined : json['leasingAgreementId'],
        'agreementNumber': !exists(json, 'agreementNumber') ? undefined : json['agreementNumber'],
        'agreementValue': !exists(json, 'agreementValue') ? undefined : json['agreementValue'],
        'firstPaymentValue': !exists(json, 'firstPaymentValue') ? undefined : json['firstPaymentValue'],
        'leasingName': !exists(json, 'leasingName') ? undefined : json['leasingName'],
        'installmentValue': !exists(json, 'installmentValue') ? undefined : json['installmentValue'],
        'installmentCount': !exists(json, 'installmentCount') ? undefined : json['installmentCount'],
        'endValue': !exists(json, 'endValue') ? undefined : json['endValue'],
        'startMileage': !exists(json, 'startMileage') ? undefined : json['startMileage'],
        'starts': !exists(json, 'starts') ? undefined : (new Date(json['starts'])),
        'ends': !exists(json, 'ends') ? undefined : (new Date(json['ends'])),
        'mileageLimit': !exists(json, 'mileageLimit') ? undefined : json['mileageLimit'],
        'finance': !exists(json, 'finance') ? undefined : LeasingFinanceFromJSON(json['finance']),
        'document': !exists(json, 'document') ? undefined : json['document'],
    };
}
export function LeasingAgreementToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'leasingAgreementId': value.leasingAgreementId,
        'agreementNumber': value.agreementNumber,
        'agreementValue': value.agreementValue,
        'firstPaymentValue': value.firstPaymentValue,
        'leasingName': value.leasingName,
        'installmentValue': value.installmentValue,
        'installmentCount': value.installmentCount,
        'endValue': value.endValue,
        'startMileage': value.startMileage,
        'starts': value.starts === undefined ? undefined : (value.starts.toISOString()),
        'ends': value.ends === undefined ? undefined : (value.ends.toISOString()),
        'mileageLimit': value.mileageLimit,
        'finance': LeasingFinanceToJSON(value.finance),
        'document': value.document,
    };
}
